import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Light theme only — clear any leftover dark-mode preference
try {
  localStorage.removeItem('darkMode');
} catch {
  // ignore
}
document.documentElement.removeAttribute('data-theme');

// Dev domains: add noindex to discourage search engine indexing
if (process.env.REACT_APP_STAGE && process.env.REACT_APP_STAGE !== 'production') {
  const meta = document.createElement('meta');
  meta.name = 'robots';
  meta.content = 'noindex, nofollow';
  document.head.appendChild(meta);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
